import type { GenerationMode, InputKind } from "./outline-types";

export const THEME_PREVIEW_IMAGES = {
  "smart-detect": new URL("./assets/ppt-theme-previews/smart-detect.webp", import.meta.url).href,
  theme01: new URL("./assets/ppt-theme-previews/theme01.webp", import.meta.url).href,
  theme02: new URL("./assets/ppt-theme-previews/theme02.webp", import.meta.url).href,
  theme03: new URL("./assets/ppt-theme-previews/theme03.webp", import.meta.url).href,
  theme04: new URL("./assets/ppt-theme-previews/theme04.webp", import.meta.url).href,
  theme05: new URL("./assets/ppt-theme-previews/theme05.webp", import.meta.url).href,
  theme06: new URL("./assets/ppt-theme-previews/theme06.webp", import.meta.url).href,
  theme07: new URL("./assets/ppt-theme-previews/theme07.webp", import.meta.url).href,
  theme08: new URL("./assets/ppt-theme-previews/theme08.webp", import.meta.url).href,
  theme09: new URL("./assets/ppt-theme-previews/theme09.webp", import.meta.url).href,
  theme10: new URL("./assets/ppt-theme-previews/theme10.webp", import.meta.url).href,
  theme11: new URL("./assets/ppt-theme-previews/theme11.webp", import.meta.url).href,
  theme12: new URL("./assets/ppt-theme-previews/theme12.webp", import.meta.url).href,
} as const;

export type ThemePreviewPack = keyof typeof THEME_PREVIEW_IMAGES;

export interface ThemeOption {
  key: string;
  mode: GenerationMode;
  name: string;
  description: string;
  previewThemePack: ThemePreviewPack;
  previewImageUrl?: string;
  recommended?: boolean;
}

export const THEME_OPTIONS = [
  { key: "theme01", mode: "standard", name: "轻拟态风", description: "产品介绍 · 企业汇报", previewThemePack: "theme01" },
  { key: "theme02", mode: "standard", name: "炫光紫绿风", description: "科技发布 · AI 创新", previewThemePack: "theme02" },
  { key: "theme03", mode: "standard", name: "深浅代码风", description: "技术方案 · 系统架构", previewThemePack: "theme03" },
  { key: "theme04", mode: "standard", name: "玻璃糖果风", description: "年轻品牌 · 创意提案", previewThemePack: "theme04" },
  { key: "theme05", mode: "standard", name: "色谱图表风", description: "数据报告 · KPI 复盘", previewThemePack: "theme05" },
  { key: "theme06", mode: "standard", name: "深色图谱风", description: "战略分析 · 高密度数据", previewThemePack: "theme06" },
  { key: "theme07", mode: "standard", name: "冷白调研风", description: "调研报告 · 白皮书", previewThemePack: "theme07" },
  { key: "theme08", mode: "standard", name: "黑金实验风", description: "高端发布 · 品牌提案", previewThemePack: "theme08" },
  { key: "theme09", mode: "standard", name: "深蓝杂志风", description: "品牌故事 · 深度专题", previewThemePack: "theme09" },
  { key: "theme10", mode: "standard", name: "金色指数风", description: "金融数据 · 投资报告", previewThemePack: "theme10" },
  { key: "theme11", mode: "standard", name: "高能增长风", description: "增长复盘 · 融资路演", previewThemePack: "theme11" },
  { key: "theme12", mode: "standard", name: "声波霓虹风", description: "音乐娱乐 · 潮流活动", previewThemePack: "theme12" },
  { key: "smart-detect", mode: "image", name: "智能检测", description: "根据资料文字、备注和图片，自动推测并生成专属视觉风格", previewThemePack: "smart-detect", recommended: true },
  { key: "business-blue", mode: "image", name: "商务蓝", description: "企业汇报 · 商业方案", previewThemePack: "theme01" },
  { key: "executive-navy", mode: "image", name: "高管深蓝", description: "战略复盘 · 投融资表达", previewThemePack: "theme10" },
  { key: "minimal-light", mode: "image", name: "极简亮色", description: "产品故事 · 培训课程", previewThemePack: "theme09" },
  { key: "data-editorial", mode: "image", name: "数据研报", description: "数据分析 · 财经研报", previewThemePack: "theme05" },
  { key: "tech-dark", mode: "image", name: "深色科技", description: "AI 产品 · 技术方案", previewThemePack: "theme02" },
  { key: "warm-story", mode: "image", name: "暖调叙事", description: "产品故事 · 品牌表达", previewThemePack: "theme04" },
] satisfies readonly ThemeOption[];

export function themeOptionsForMode(mode: GenerationMode, _sourceMode?: InputKind): ThemeOption[] {
  return THEME_OPTIONS.filter((theme) => theme.mode === mode);
}
